<template>
  <div id="appmain">
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from 'vuex'
import _ from 'lodash'

//import '../public/img/logo.jpg'

export default {
  name: 'app',
  data: function() {
    return {
      isCollapse: false,
      loading: true,
    }
  },
  methods: {
    ...mapActions([
      'getProfile', 'logout'
    ]),
    loadProfile() {
      this.getProfile()
    },
  },
  mounted() {

    // setup default axios behavior here
    //const _csrf = document.getElementById("_csrf");
    //axios.defaults.headers.common[_csrf.name] = _csrf.value;

    this.loading = false;

    axios.interceptors.request.use(async config => {
      //config.headers.token = await firebase.auth().currentUser.getIdToken()


      return config
    }, (error) => {
      return Promise.reject(error)
    })

    axios.interceptors.response.use((response) => {
      if (response.headers["x-wrc-login"] == "1") {
        this.$alert('Your session has expired. Please relogin.', 'Session', {
          type: 'warning',
          showClose: false,
          confirmButtonText: 'OK',
          callback: action => {
            window.location.reload();
          }
        });

        return;
      }

      return response;
    }, (error) => {
      // Globally catch all errors
      
      let message
      if (error.response) {
        message = error.response.data;
      } else if (error.request) {
        message = "No response received!";
      } else {
        message = error.message;
      }

      // some 404 response is being used in the service
      if (error.response.status != 404) {
        if (error.response.status == 401 || error.response.status == 403) {
          // token expired, for now log out user
          this.logout()
        } else {
          if (error.response.status == 500) {
            message = "Server has encountered error. This has been logged in the system. Please report to admin for issue fixes.";

            
          } else {
            // TODO: use this and refine message from server
            
            if (typeof message === 'object' && message != null && !_.isUndefined(message.message)) {
              message = message.message
            } else if (typeof message === 'object' && message != null && !_.isUndefined(message.error)) {
              message = message.error.message
            }
          }

          this.$message({
              type: 'error',
              showClose: true,
              message
            });
        }
        
        return Promise.reject(error);
      }
    });

    //this.initGlobalLoader();

    this.loadProfile();
  }
}

</script>

